module.exports = __webpack_public_path__ + "static/media/1.iPhone_1.06816e1c.png";